// extracted by mini-css-extract-plugin
export var Icon = "style-module--Icon--4b6f8";
export var Interest = "style-module--Interest--4bfd4";
export var Interests = "style-module--Interests--3d3b3";